module.exports = __webpack_public_path__ + "img/icon_FB.76590a49.svg";